import { Injectable } from '@angular/core';
import { IAutheticationNiceResponse } from '../../data/CXOne/util/Nice-authentication-response';

@Injectable({
  providedIn: 'root',
})
export class NiceAuthenticationResponseService {
  private niceAuhtenticationResponseKeyInLocalStorage =
    'nice-authentication-response';

  toStringify(data: IAutheticationNiceResponse) {
    const dataString = JSON.stringify(data);
    return dataString;
  }

  toJson(data: string): IAutheticationNiceResponse {
    const dataJson = JSON.parse(data);
    return dataJson;
  }

  get localStorageKey() {
    return this.niceAuhtenticationResponseKeyInLocalStorage;
  }
}
